import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { useSelector } from 'react-redux';
import { CMXIcon, Conditional } from '@codametrix/ui-components';
import { createPortal } from 'react-dom';
import { LoadingSlugs } from '@codametrix/ui-components';
import './provider-details.scss';
import { Avatar } from '@chakra-ui/react';
import { objectUtils } from '@codametrix/ui-common';
import * as userUtils from '../../core/utils/user-utils';
const fallbackElement = document.createElement('div');
const getEmployerStatus = (providerInfo)=>{
    return providerInfo?.specialties?.[0]?.report_grouper_six || providerInfo?.specialties?.[0]?.employment_designation;
};
const ProviderDetails = ()=>{
    const { isOpen, providerInfo, providerInfoInput, isSingleTenantData, servicesLoading } = useSelector((state)=>{
        return state.providerDetails;
    });
    const colorCodes = [
        '#346EA3',
        '#F6844E',
        '#5BA37A',
        '#F1C54B',
        '#688D99',
        '#F24646',
        '#867775',
        '#E15A6A',
        '#BB529E',
        '#B97350'
    ];
    const employerStatus = getEmployerStatus(providerInfo);
    const specialtiesByLoc = objectUtils.groupBy(providerInfo?.specialties ?? [], 'location');
    const specialtiesView = Object.entries(specialtiesByLoc)?.map(([location, locationGroup])=>{
        const specialtiesByRole = objectUtils.groupBy(locationGroup ?? [], 'name');
        return Object.entries(specialtiesByRole)?.map(([name, specialties])=>{
            const isRoleBillable = specialties?.some((specialty)=>specialty?.billable);
            return /*#__PURE__*/ _jsxs("div", {
                className: "vertical-info specialty-row",
                children: [
                    location && location !== 'null' && /*#__PURE__*/ _jsx("div", {
                        className: "provider-location",
                        "data-testid": "provider-location",
                        children: isSingleTenantData ? name : location
                    }),
                    /*#__PURE__*/ _jsxs("div", {
                        className: "flex-box",
                        children: [
                            !isSingleTenantData && /*#__PURE__*/ _jsxs("div", {
                                className: "provider-role vertical-info ",
                                "data-testid": "provider-role",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "info-header",
                                        children: "ROLE"
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "info-cell",
                                        children: name
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "provider-specialties vertical-info",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "info-header",
                                        children: "SPECIALTY"
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "info-cell",
                                        children: specialties?.map((specialty)=>{
                                            return specialty?.specialty && /*#__PURE__*/ _jsx("div", {
                                                className: "specialty-name chip label",
                                                "data-testid": "specialty-name",
                                                children: specialty?.specialty
                                            });
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "provider-specialties vertical-info",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "info-header",
                                        children: "SPECIALTY STATUS"
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "info-cell sepcialty_status",
                                        children: specialties?.map((specialty)=>{
                                            return specialty?.specialty_flag && /*#__PURE__*/ _jsx("div", {
                                                className: "specialty-flag",
                                                children: specialty?.specialty_flag
                                            });
                                        })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "vertical-info billable",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "info-header",
                                        children: "BILLABLE?"
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "info-cell billable_flag",
                                        "data-testid": "billable-flag",
                                        children: [
                                            /*#__PURE__*/ _jsx(Conditional, {
                                                on: isRoleBillable,
                                                children: /*#__PURE__*/ _jsx(CMXIcon, {
                                                    svgTitleText: "Billable",
                                                    svgIconName: "BiomeCheckCircle",
                                                    svgIconClass: "billing-icon",
                                                    svgIconSize: "16"
                                                })
                                            }),
                                            /*#__PURE__*/ _jsx(Conditional, {
                                                on: !isRoleBillable,
                                                children: /*#__PURE__*/ _jsx(CMXIcon, {
                                                    svgTitleText: "Not billable",
                                                    svgIconName: "BiomeNoCircle",
                                                    svgIconClass: "no-billing-icon",
                                                    svgIconSize: "16"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }, location);
        });
    });
    return /*#__PURE__*/ _jsx(Conditional, {
        on: isOpen,
        children: servicesLoading ? /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ createPortal(/*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(LoadingSlugs, {
                            width: "25",
                            numberItems: 1
                        }, "loading-slugs"),
                        /*#__PURE__*/ _jsx(LoadingSlugs, {
                            width: "25",
                            numberItems: 1
                        }, "loading-slugs"),
                        /*#__PURE__*/ _jsx(LoadingSlugs, {
                            width: "80",
                            numberItems: 1
                        }, "loading-slugs")
                    ]
                }), document.getElementById('cmx-drawer-header') || fallbackElement),
                /*#__PURE__*/ createPortal(/*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(LoadingSlugs, {
                            numberItems: 3
                        }, "loading-slugs"),
                        /*#__PURE__*/ _jsx("br", {}),
                        /*#__PURE__*/ _jsx(LoadingSlugs, {
                            width: "60",
                            numberItems: 5
                        }, "loading-slugs"),
                        /*#__PURE__*/ _jsx("br", {}),
                        /*#__PURE__*/ _jsx(LoadingSlugs, {
                            width: "60",
                            numberItems: 5
                        }, "loading-slugs"),
                        /*#__PURE__*/ _jsx("br", {}),
                        /*#__PURE__*/ _jsx(LoadingSlugs, {
                            width: "60",
                            numberItems: 5
                        }, "loading-slugs")
                    ]
                }), document.getElementById('cmx-drawer-body') || fallbackElement)
            ]
        }) : /*#__PURE__*/ _jsxs(_Fragment, {
            children: [
                /*#__PURE__*/ _jsx(Conditional, {
                    on: !!document.getElementById('cmx-drawer-header'),
                    children: /*#__PURE__*/ _jsx(_Fragment, {
                        children: /*#__PURE__*/ createPortal(/*#__PURE__*/ _jsxs("div", {
                            className: "provider-header-section provider-details",
                            children: [
                                /*#__PURE__*/ _jsx(Avatar, {
                                    name: userUtils.getAvatarInitialsByFullName(providerInfo?.provider_name ?? providerInfoInput?.providerName ?? ''),
                                    bgColor: colorCodes[Math.floor(Math.random() * colorCodes.length)]
                                }),
                                /*#__PURE__*/ _jsxs("div", {
                                    children: [
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "provider-name",
                                            "data-testid": "provider-name",
                                            children: [
                                                providerInfo?.provider_name ?? providerInfoInput?.providerName,
                                                ' ',
                                                providerInfo?.prov_cred
                                            ]
                                        }),
                                        /*#__PURE__*/ _jsxs("div", {
                                            className: "employee-info",
                                            children: [
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "vertical-info",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("span", {
                                                            className: "info-header",
                                                            children: "EHR ID"
                                                        }),
                                                        /*#__PURE__*/ _jsx("span", {
                                                            className: "info-cell ehr-id",
                                                            "data-testid": "ehr-id",
                                                            children: providerInfo?.provider_id ?? providerInfoInput?.providerNumber
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsxs("div", {
                                                    className: "vertical-info ",
                                                    children: [
                                                        /*#__PURE__*/ _jsx("span", {
                                                            className: "info-header",
                                                            children: "EMPLOYER"
                                                        }),
                                                        /*#__PURE__*/ _jsx(Conditional, {
                                                            every: [
                                                                !!employerStatus
                                                            ],
                                                            children: /*#__PURE__*/ _jsx("span", {
                                                                className: `info-cell employer-status chip label ${employerStatus?.toUpperCase() === 'EXTERNAL PROVIDER' ? 'external-provider' : ''}`,
                                                                children: employerStatus
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ _jsx(Conditional, {
                                                    on: isSingleTenantData,
                                                    children: /*#__PURE__*/ _jsxs("div", {
                                                        className: "vertical-info",
                                                        children: [
                                                            /*#__PURE__*/ _jsx("span", {
                                                                className: "info-header",
                                                                children: "FACILITY"
                                                            }),
                                                            /*#__PURE__*/ _jsx("span", {
                                                                className: "info-cell facility",
                                                                "data-testid": "facility",
                                                                children: providerInfoInput?.tenantCode
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }), document.getElementById('cmx-drawer-header') || fallbackElement)
                    })
                }),
                /*#__PURE__*/ _jsx(Conditional, {
                    on: !!document.getElementById('cmx-drawer-body'),
                    children: /*#__PURE__*/ _jsx(_Fragment, {
                        children: /*#__PURE__*/ createPortal(/*#__PURE__*/ _jsxs("div", {
                            className: "provider-body-section provider-details",
                            children: [
                                /*#__PURE__*/ _jsx(Conditional, {
                                    on: !!!providerInfo,
                                    children: /*#__PURE__*/ _jsx("span", {
                                        className: "empty-message",
                                        "data-testid": "empty-message",
                                        children: "No roles available for this provider."
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Conditional, {
                                    on: !!providerInfo,
                                    children: /*#__PURE__*/ _jsx(_Fragment, {
                                        children: specialtiesView
                                    })
                                })
                            ]
                        }), document.getElementById('cmx-drawer-body') || fallbackElement)
                    })
                })
            ]
        })
    });
};
ProviderDetails.displayName = 'ProviderDetails';
export { ProviderDetails };
